<template>
    <a-config-provider :locale="locale">
        <router-view />
        <SettingDrawer />
    </a-config-provider>
</template>

<script>
import zhCN from "ant-design-vue/es/locale/zh_CN";
import SettingDrawer from "./components/other/SettingDrawer";

export default {

    components: { SettingDrawer },
    setup() {
        const keyCodeMap = {
            // 91: true, // command
            61: true,
            107: true, // 数字键盘 +
            109: true, // 数字键盘 -
            173: true, // 火狐 - 号
            187: true, // +
            189: true, // -
        };
        // 覆盖ctrl||command + ‘+’/‘-’
        document.onkeydown = function (event) {
            const e = event || window.event;
            const ctrlKey = e.ctrlKey || e.metaKey;
            if (ctrlKey && keyCodeMap[e.keyCode]) {
                e.preventDefault();
            } else if (e.detail) { // Firefox
                event.returnValue = false;
            }
        };
        // 覆盖鼠标滑动
        document.body.addEventListener('wheel', (e) => {
            if (e.ctrlKey) {
                if (e.deltaY < 0) {
                    e.preventDefault();
                    return false;
                }
                if (e.deltaY > 0) {
                    e.preventDefault();
                    return false;
                }
            }
        }, { passive: false });
        let elLoadingMask = document.getElementById("loading-mask");
        if (elLoadingMask) {
            elLoadingMask.remove();
        }
        return {
            locale: zhCN
        }
    },
};
</script>

<style lang="less">
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected{
    background-color: #0059b5 !important;
}
</style>
